import type {
    FC
} from "react";
import {
    View
} from "react-native";
import type IQuestionnaireErrorProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme
} from "../../../../core/hooks";
import type {
    QuestionnaireItemPartContentProps
} from "../../type";
import {
    CircleAlert as CircleAlertIcon
} from "lucide-react-native";
import {
    withQuestionnaireItemContext
} from "../../context";
import Text from "../../../text";

const QuestionnaireErrorContent: FC<QuestionnaireItemPartContentProps<IQuestionnaireErrorProps>> = ({
    customTheme: customThemeProp,
    itemContext,
    children,
    context,
    style,
    ...props
}) => {
    const customTheme = customThemeProp ?? context.customTheme;

    const {
        iconSizes,
        colors,
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        localize
    } = NCoreUIKitLocalize.useContext(context.customLocalize);

    const {
        container: containerDynamicStyle
    } = useStyles({
        spaces
    });

    if(!itemContext.isInvalid) {
        return null;
    }

    return <View
        {...props}
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle
        ]}
        id={itemContext.errorId}
    >
        <CircleAlertIcon
            color={colors.content.text.danger}
            size={iconSizes.small}
        />
        <Text
            customColor={colors.content.text.danger}
            customTheme={customTheme}
            style={stylesheet.text}
            variant="bodySmallSize"
        >
            {children ?? itemContext.item.errorMessage ?? localize("questionnaire-required")}
        </Text>
    </View>;
};
export default withQuestionnaireItemContext("Error", QuestionnaireErrorContent);
